import pageTitle from 'ember-page-title/helpers/page-title';

<template>
  {{pageTitle "NAIS Market View"}}

  {{outlet}}
</template>
